/**
 * Dark-mode `sx` helpers for PamGrid and its surrounding toolbar.
 *
 * AG Grid styling itself is handled by PamGrid via the AG Grid v33 theme API
 * (`themeQuartz.withPart(colorSchemeDark)`), so no CSS overrides are needed
 * for headers, rows, menus, etc. The helper here covers what AG Grid's theme
 * doesn't reach: MUI's disabled-button styling on the surrounding toolbar.
 */

/**
 * `containerSx` overrides for PamGrid in dark mode.
 *
 * GridToolbar's hardcoded `BUTTON_STYLES.disabled` uses `rgba(0,0,0,0.26)`
 * text on `rgba(0,0,0,0.12)` background — invisible on a dark surface. We
 * replace those with MUI's standard dark-mode disabled tokens
 * (`palette.text.disabled` / `palette.action.disabledBackground`) so disabled
 * buttons read like every other MUI disabled control. The explicit icon-color
 * override is needed because MUI applies its own disabled colour to
 * `MuiSvgIcon-root` that wins against the parent button's text colour.
 *
 * Returns `{}` in light mode (no-op).
 */
export function getDarkContainerSx(theme) {
  if (theme.palette.mode !== 'dark') return {};
  const disabledText = theme.palette.text.disabled;
  const disabledBg = theme.palette.action.disabledBackground;
  return {
    '& .MuiButton-root.Mui-disabled': {
      color: `${disabledText} !important`,
      backgroundColor: `${disabledBg} !important`,
      borderColor: `${disabledBg} !important`,
      '& .MuiButton-startIcon, & .MuiButton-endIcon, & .MuiSvgIcon-root': {
        color: `${disabledText} !important`,
      },
    },
  };
}
